import * as React from "react";
import type { SVGProps } from "react";
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#gift_svg__a)">
      <path d="M21 14H3c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1h18c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1M4 12h16v-2H4z" />
      <path d="M19 22H5c-.55 0-1-.45-1-1v-8c0-.55.45-1 1-1s1 .45 1 1v7h12v-7c0-.55.45-1 1-1s1 .45 1 1v8c0 .55-.45 1-1 1M12 10H8.92C6.76 10 5 8.24 5 6.08v-.16C5 3.76 6.76 2 8.92 2h.16C11.24 2 13 3.76 13 5.92V9c0 .55-.45 1-1 1M8.92 4C7.86 4 7 4.86 7 5.92v.16C7 7.14 7.86 8 8.92 8H11V5.92C11 4.86 10.14 4 9.08 4z" />
      <path d="M14.27 10H12c-.55 0-1-.45-1-1V6.73c0-1.81 1.47-3.27 3.27-3.27s3.27 1.47 3.27 3.27S16.07 10 14.27 10M13 8h1.27c.7 0 1.27-.57 1.27-1.27s-.57-1.27-1.27-1.27S13 6.03 13 6.73z" />
      <path d="M12 22c-.55 0-1-.45-1-1V8.68c0-.55.45-1 1-1s1 .45 1 1V21c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="gift_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGift;
